import { useState,useEffect } from "react";
import { useDispatch } from "react-redux";
import { update } from "store/cart/actions";
import { syncCart } from "store/cart/actions";
import { useCart } from "hooks";

const QuantityUpdate = ({ quantity, id, inventoryCount = 10 }) => {
  const dispatch = useDispatch();
  const [counter, setCounter] = useState(quantity);
  const { items, subTotal, discount, coupon, totalQuantity } = useCart();

  // ← Add this: keep local counter in sync with prop
  useEffect(() => {
    setCounter(quantity);
  }, [quantity]);

  const MAX_PER_USER = 6;

  const handleIncrement = () => {
    const nextQty = counter + 1;

    if (nextQty > inventoryCount || nextQty > MAX_PER_USER) return;

    setCounter(nextQty);
    dispatch(update(id, nextQty));

  };

  const handleDecrement = () => {
    const nextQty = counter - 1;
    if (nextQty < 1) return;

    setCounter(nextQty);
    dispatch(update(id, nextQty));

  };

  const isIncrementDisabled =
    counter >= inventoryCount || counter >= MAX_PER_USER;

  return (
    <div className="wrapper d-flex align-items-center">
      <span
        onClick={handleDecrement}
        className={`minus ${counter <= 1 ? "disabled" : ""}`}
        role="button" // better accessibility
        tabIndex={0}
      >
        -
      </span>
      <span className="num mx-2">{counter}</span>
      <span
        onClick={handleIncrement}
        className={`plus ${isIncrementDisabled ? "disabled" : ""}`}
        title={
          counter >= inventoryCount
            ? "No more stock available"
            : counter >= MAX_PER_USER
              ? "Limit of 6 per user"
              : "Increase quantity"
        }
        role="button"
        tabIndex={0}
      >
        +
      </span>
    </div>
  );
};

export default QuantityUpdate;
